import React from 'react';
import { Route, Routes } from 'react-router-dom';
import CRMLanding from '../modules/crm/pages/CRMLanding';
import Customers from '../modules/crm/pages/Customers';
import CustomerDetail from '../modules/crm/pages/CustomerDetailModern';
import SiteDetail from '../SiteDetailModern';
import Prospects from '../modules/crm/pages/Prospects';
import ProspectDetail from '../modules/crm/pages/ProspectDetail';
import SalesOrders from '../modules/crm/pages/SalesOrders';
import SalesOrderDetail from '../modules/crm/pages/SalesOrderDetail';
import Sites from '../modules/crm/pages/Sites';
import Suppliers from '../modules/ops/pages/Suppliers';
import SupplierDetail from '../modules/ops/pages/SupplierDetail';

const CrmRoutes = () => {
  return (
    <Routes>
      <Route path="" element={<CRMLanding />} />
      <Route path="customers" element={<Customers />} />
      <Route path="customers/:id" element={<CustomerDetail />} />
      <Route path="customers/:customerId/sites/:siteId" element={<SiteDetail />} />
      <Route path="prospects" element={<Prospects />} />
      <Route path="prospects/:id" element={<ProspectDetail />} />
      <Route path="sales-orders" element={<SalesOrders />} />
      <Route path="sales-orders/:id" element={<SalesOrderDetail />} />
      <Route path="sites" element={<Sites />} />
      <Route path="sites/:id" element={<SiteDetail />} />
      <Route path="suppliers" element={<Suppliers />} />
      <Route path="suppliers/:id" element={<SupplierDetail />} />
    </Routes>
  );
};

export default CrmRoutes;
